﻿export class ProductFeatureSpot {
  /**
   * Product feature spot
   */
  constructor(element) {
    this.element = this;

    // References

    this._refs = {
      el: element,

      tooltip: element.querySelectorAll('.product-feature__all-tooltips .product-feature__tooltip'),
      fullDiv: element.querySelector('product'),
      container: element.querySelector('.product-feature__container'),
    };

    window.addEventListener('resize', this._contentPosition.bind(this));
    window.addEventListener('load', this._contentPosition.bind(this));
  }
  _contentPosition() {
    let timeoutId;
    this._refs.tooltip.forEach((tooltip) => {
      const content = tooltip.querySelector('.product-feature__tooltip-content');
      const pin = tooltip.querySelector('.product-feature__tooltip-pin');
      const arrow = tooltip.querySelector('.product-feature__tooltip-content-arrow');

      if (pin.offsetLeft + content.offsetWidth / 2 > this._refs.container.offsetWidth) {
        const extraLeft =
          this._refs.container.offsetWidth - (pin.offsetLeft + content.offsetWidth / 2);
        content.style.left = pin.offsetLeft - content.offsetWidth / 2 + extraLeft + 'px';
      } else if (pin.offsetLeft + this._refs.fullDiv.offsetLeft < content.offsetWidth / 2) {
        /* eslint-disable-next-line */
      } else {
        content.style.left = pin.offsetLeft - content.offsetWidth / 2 + 'px';
      }

      //setting top content, arrow
      const height = parseInt(window.getComputedStyle(this._refs.container).height);

      if (pin.offsetTop < Math.round(height / 2)) {
        //setting content arrow to top
        arrow.classList.add('above');
        //if it's top tooltip move it down +10px for the animation
        content.style.top =
          pin.offsetTop - 12 - parseInt(window.getComputedStyle(content).height) + 10 + 'px';
        if (!tooltip.classList.contains('mobile')) {
          pin.addEventListener('mousemove', () => {
            tooltip.classList.add('active');
          });

          pin.addEventListener('mouseleave', () => {
            timeoutId = setTimeout(() => {
              tooltip.classList.remove('active');
            }, 0);
          });

          content.addEventListener('mousemove', () => {
            clearTimeout(timeoutId);
            tooltip.classList.add('active');
          });

          content.addEventListener('mouseleave', () => {
            timeoutId = setTimeout(() => {
              tooltip.classList.remove('active');
            }, 0);
          });
        } else {
          pin.addEventListener('click', () => {
            tooltip.classList.add('active');
          });

          const close = content.querySelector('.product-feature__tooltip-content-content-close');
          if (close != null) {
            close.addEventListener('click', () => {
              tooltip.classList.remove('active');
            });
          }
        }
      } else {
        //if it's top tooltip move it down -10px for the animation
        content.style.top = pin.offsetTop + 52 - 10 + 'px';

        if (!tooltip.classList.contains('mobile')) {
          pin.addEventListener('mousemove', () => {
            tooltip.classList.add('active-bottom');
          });

          pin.addEventListener('mouseleave', () => {
            timeoutId = setTimeout(() => {
              tooltip.classList.remove('active-bottom');
            }, 0);
          });

          content.addEventListener('mousemove', () => {
            clearTimeout(timeoutId);
            tooltip.classList.add('active-bottom');
          });

          content.addEventListener('mouseleave', () => {
            timeoutId = setTimeout(() => {
              tooltip.classList.remove('active-bottom');
            }, 0);
          });
        } else {
          pin.addEventListener('click', () => {
            tooltip.classList.add('active');
          });

          const close = content.querySelector('.product-feature__tooltip-content-content-close');
          if (close != null) {
            close.addEventListener('click', () => {
              tooltip.classList.remove('active');
            });
          }
        }
      }

      arrow.style.left = pin.offsetLeft - content.offsetLeft + pin.offsetWidth / 2 + 'px';

      content.style.transition = 'all 0.75s ease-in-out';
    });
  }
}
